import { combineReducers } from 'redux';
import settings from './settings';
import AuthSlice from "../pages/Authentication/store/authSlice"
import ProfileSlice from "../pages/Users/store/profileSlice"

export default combineReducers({
    settings,
    auth: AuthSlice,
    profile: ProfileSlice
});